import React, {useState, useEffect} from 'react'

import classes from './PopupFTUE.module.css'
import PopupsManager from 'react-sdk/PopupsManager';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import Texts from 'react-sdk/Texts';
import Media from '../Media/Media';
import Button from '@/components/shared/Button/Button';
import AppState, { POPUPS } from '@/js/AppState';
import Popup from '@/components/shared/Popup/Popup';
import Ftues from '@/js/Ftues';
import clsx from 'clsx';

/**
 * @param {Object} props
 * @param {Ftue} props.page
 * @param {boolean} props.isLast
 */
const Page = ({page, isLast}) => {

  useEffect(() => {
    // TODO vérif un peu plus poussée ??
    if(page.Character) AppState.playSingleDial(page)
  }, [page]);

  function handleClose() {
    PopupsManager.close(POPUPS.FTUE)
  }

  return (
    <div className={classes.page}>
      <div>
        <h1 className={classes.surtitle} dangerouslySetInnerHTML={{__html: page.surtitle}} ></h1>
        <div className={classes.title} dangerouslySetInnerHTML={{__html: page.title}} ></div>
      </div>

      <div className={classes.page_content}>

        {/* <div className={classes.image}>
          <Media path="data/images/plateau.png" />
        </div> */}
        {page.image &&
        <div className={classes.image}>
          <Media path={page.image} />
        </div>}
        <div className={classes.text} dangerouslySetInnerHTML={{__html: page.Text}} />

      </div>

      <div className={clsx(classes.btnCtnr, !isLast && classes.invisible)}>
        <Button onClick={handleClose}>
          {Texts.get("ftue-popup-next-btn")}
        </Button>
      </div>

      {!isLast && <div />}
    </div>
  )
}



const PopupFTUE = () => {

  const [currentPage, setCurrentPage] = useState(0);

  let ftueId = PopupsManager.getData(POPUPS.FTUE)
  let data = Ftues.get(ftueId)

  if(!data) return null

  return (

    <Popup className={classes.PopupFTUE}>
      <div className={classes.PopupFTUE_content}>
        <Page page={data[currentPage]} isLast={currentPage === data.length - 1} />

        {currentPage > 0 &&
        <Button
        className={classes.prevBtn}
        icon={<FaChevronLeft />}
        onClick={() => setCurrentPage(p => p-1)}
        />}

        {currentPage < data.length - 1 &&
        <Button
        className={classes.nextBtn}
        icon={<FaChevronRight />}
        onClick={() => setCurrentPage(p => p+1)}
        />}

      </div>
    </Popup>
  );
};

export default PopupFTUE;
